import { css } from '@emotion/react';

import { colorConstants } from 'config/colorConstants';

export const packArchitectureTableHoverStyles = css`
    .ant-table-tbody > tr > td.table-cell-hover-row {
        background: ${colorConstants.tableHoverCrossFill} !important;
    }

    .ant-table-tbody > tr > td.table-cell-hover-row.ant-table-cell-fix-left {
        background: ${colorConstants.tableRowAxisHoverFill} !important;
        border-bottom: 1px solid ${colorConstants.tableColorSplit} !important;
    }

    .ant-table-tbody > tr > td.table-cell-hover-column {
        background: ${colorConstants.tableHoverCrossFill} !important;
        border-bottom: 1px solid ${colorConstants.greyAlt6} !important;
        mix-blend-mode: multiply;
    }

    .ant-table-tbody > tr > td.table-cell-hover-active {
        background: ${colorConstants.tabBackground} !important;
        border-bottom: 1px solid ${colorConstants.greyAlt} !important;
        mix-blend-mode: normal;
    }

    .ant-table-thead > tr > th.table-header-hover-column {
        background: ${colorConstants.tableHeaderHoverBg} !important;
        border-bottom: 1px solid ${colorConstants.tableColorSplit} !important;
    }

    .ant-table-tbody > tr:hover > td.table-cell-hover-row,
    .ant-table-tbody > tr:hover > td.table-cell-hover-column,
    .ant-table-tbody > tr:hover > td.table-cell-hover-active {
        mix-blend-mode: inherit;
    }

    .ant-table-tbody > tr:hover > td.table-cell-hover-row {
        background: ${colorConstants.tableHoverCrossFill} !important;
    }

    .ant-table-tbody > tr:hover > td.table-cell-hover-column {
        background: ${colorConstants.tableHoverCrossFill} !important;
    }

    .ant-table-tbody > tr:hover > td.table-cell-hover-active {
        background: ${colorConstants.tabBackground} !important;
    }

    .ant-table-tbody > tr:hover > td.table-cell-hover-row.ant-table-cell-fix-left {
        background: ${colorConstants.tableRowAxisHoverFill} !important;
    }
`;
